import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_LUXON_DATE_ADAPTER_OPTIONS, MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { CoreModule } from '@core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { EnumLabelPipe } from '@pipes/common/enum-label.pipe';
import { PipesModule } from '@pipes/pipes.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DatePickerInputComponent } from './components/date-picker-input/date-picker-input.component';
import { ErrorWrapperComponent } from './components/error-wrapper/error-wrapper.component';
import { IconWarningComponent } from './components/icon-warning/icon-warning.component';
import { RadioButtonGroupComponent } from './components/radio-button-group/radio-button-group.component';
import { SelectComponent } from './components/select/select.component';
import { UserPickerComponent } from './components/user-picker/user-picker.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

@NgModule({
  exports: [
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatMenuModule,
    MatProgressBarModule,
    MatCardModule,
    MatExpansionModule,
    MatTreeModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatListModule,
    CheckboxModule,
    MatAutocompleteModule,
    MatStepperModule,
    AutoCompleteModule,
    MatLuxonDateModule,
    UserPickerComponent,
    DropdownModule,
    ToggleButtonModule,
    BadgeModule,
    ErrorWrapperComponent,
    IconWarningComponent,
    RadioButtonGroupComponent,
    SelectComponent,
    DatePickerInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatProgressBarModule,
    MatButtonModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatCardModule,
    MatTableModule,
    MatExpansionModule,
    MatTreeModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatListModule,
    CheckboxModule,
    MatAutocompleteModule,
    MatStepperModule,
    MatLuxonDateModule,
    CoreModule,
    PipesModule,
    TranslateModule.forChild(),
    AutoCompleteModule
  ],
  providers: [
    MatDatepickerModule,
    MatLuxonDateModule,
    { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    EnumLabelPipe
  ],
  declarations: [
    UserPickerComponent,
    IconWarningComponent,
    ErrorWrapperComponent,
    LogoutComponent,
    UnauthorizedComponent,
    PageNotFoundComponent,
    RadioButtonGroupComponent,
    SelectComponent,
    DatePickerInputComponent
  ]
})
export class SharedModule {}
